export default __webpack_public_path__ + "static/media/330_dummy2016-personal01-mobile-de.ec43e806.png";